
import { Vue, Component, Prop } from "vue-property-decorator";
import { printPluginDownloadUrl, pdfReaderDownloadUrl } from "../config";
@Component
export default class wmsPrintPdfGuides extends Vue {
  pluginDownloadUrl = printPluginDownloadUrl;
  pdfReaderDownloadUrl = pdfReaderDownloadUrl;
  mounted() {
    document.title = "打印教程｜常见问题";
  }
}
